// src/components/display/DisplayStructure.js
import React from 'react';
import StructureDisplayRow from '../structure/StructureDisplayRow';
import {
  StructureTableArea,
  ScrollableStructureTableWrapper,
  DisplayStructureTable,
  StyledTh,
} from '../../styles/displayStructureStyles';

const createLocalizedHeader = (columns, isMobilePortrait, t, levelKey, timeKey) => {
  if (isMobilePortrait) {
    return [t('common.level'), t('display.blindEtcLabel'), t('common.time')];
  }
  return columns.map(({ label }) => {
    if (label === levelKey) return t('common.level');
    if (label === timeKey) return t('common.time');
    return t(label) || label;
  });
};

const DisplayStructure = ({
  palette,
  structure,
  rowIndex,
  isMobilePortrait,
  t,
  appConfig,
}) => {
  if (!structure || !structure.columns || !structure.levels) return null;

  const { requiredLevelKey: levelKey, requiredTimeKey: timeKey } = appConfig;
  const localizedHeader = createLocalizedHeader(structure.columns, isMobilePortrait, t, levelKey, timeKey);

  let startIdx = 0;
  if (structure && structure.levels) {
    const total = structure.levels.length;
    if (rowIndex <= 0) {
      startIdx = 0;
    } else if (rowIndex >= total - 1) {
      startIdx = Math.max(0, total - 3);
    } else {
      startIdx = rowIndex - 1;
    }
  }

  return (
    <StructureTableArea>
      <ScrollableStructureTableWrapper>
        <DisplayStructureTable $palette={palette}>
          <thead>
            <tr>
              {localizedHeader.map((hdr, i) => (<StyledTh $palette={palette} key={i}>{hdr}</StyledTh>))}
            </tr>
          </thead>
          <tbody>
            {structure.levels.slice(startIdx, Math.min(startIdx + 3, structure.levels.length)).map((row, idx) => (
              <StructureDisplayRow
                key={row.id || `row-${startIdx + idx}`}
                row={row}
                columns={structure.columns}
                isCurrent={startIdx + idx === rowIndex}
                isMobilePortrait={isMobilePortrait}
                palette={palette}
                t={t}
                levelKey={levelKey}
                timeKey={timeKey}
                overallIndex={startIdx + idx}
                events={structure.events}
              />
            ))}
          </tbody>
        </DisplayStructureTable>
      </ScrollableStructureTableWrapper>
    </StructureTableArea>
  );
};

export default React.memo(DisplayStructure);